<template>
  <div>
    <b-form-group
        v-if="field.type === 'TEXT'"
        :label="field.label"
        :label-for="field.label"
    >
      <ValidationProvider
          :name="field.label"
          :rules="getValidationRules(field)"
          v-slot="{ errors }"
      >
        <b-form-textarea
            :id="field.label"
            :state="errors.length > 0 ? false : null"
            :placeholder="field.label"
            disabled
            v-model="valueField"
            @input="handleInput"
            rows="3"
            max-rows="6"
        ></b-form-textarea>
        <b-form-invalid-feedback v-if="errors.length > 0">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </ValidationProvider>
    </b-form-group>

    <b-form-group
        v-else
        :label="field.label"
        :label-for="field.label"
    >
      <ValidationProvider
          :name="field.label"
          :rules="getValidationRules(field)"
          v-slot="{ errors }"
      >
        <b-form-input
            :id="field.label"
            :state="errors.length > 0 ? false : null"
            :placeholder="field.label"
            disabled
            :type="getFieldInputType(field.type)"
            v-model="valueField"
            @input="handleInput"
        ></b-form-input>
        <b-form-invalid-feedback v-if="errors.length > 0">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </ValidationProvider>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'InputCustom',
  props: {
    field: {
      type: Object,
      required: true,
    },
    valueField: {
      type: String,
      required: false,
    },
  },
  methods: {
    getValidationRules(field) {
      return field.required ? 'required' : '';
    },
    getFieldInputType(type) {
      const typeMapping = {
        VARCHAR: 'text',
        INTEGER: 'number',
        DECIMAL: 'number',
        TIMESTAMP: 'datetime-local',
        BOOLEAN: 'checkbox',
        DATETIME: 'datetime-local',
        DATE: 'date',
        ENUM_OPTIONS: 'select',
        TEXT: 'textarea',
      };

      // Retorne o tipo correspondente ou um valor padrão
      return typeMapping[type] || 'text';
    },
    handleInput() {
      this.$emit('input', this.valueField);
    },
  },
};
</script>

<style scoped lang="scss">
/* Adicione estilos conforme necessário */
</style>
